import config from '@/config'

export default class SystemModuleConfig{
  static getConsoleVersion(): string {
    return config.systemModules.console.version
  }
  static getAuthVersion(): string {
    return config.systemModules.auth.version
  }
  static getLockScreenVersion(): string {
    return config.systemModules.lockScreen.version
  }
  static getSyncVersion(): string {
    return config.systemModules.sync.version
  }
  static getShareVersion(): string {
    return config.systemModules.share.version
  }
  static getWinManagerVersion(): string {
    return config.systemModules.winManager.version
  }
  static getModManagerVersion(): string {
    return config.systemModules.modManager.version
  }
  static getUpdateVersion(): string {
    return config.systemModules.update.version
  }
  static getGroupsVersion(): string {
    return config.systemModules.groups.version
  }
}
